<template>
  <div class="b_fff p_20 b_b font18 c_878787" style="height:100%;">
		<!-- display: flex; flex-direction: row;  align-items: center; -->
		<div>
			<img src="../../../assets/errtriangle.png" class="w30" alt="">
			<div style="border-bottom: 2px solid #CFCFCF" class="p_t_b_10">页面加载失败，您可以尝试：</div>
			<div class="p_t_b_10">
				<div class="d_in v_t t_l" style="width: 30px">
					<img src="../../../assets/icon_step1.png" class="w70" alt="">
					</div><div class="d_in v_m" style="width: calc(100% - 30px)"
				>点击左上角关闭按钮，然后重新进入该页面</div>
			</div>
			<div class="p_t_b_10">
				<div class="d_in v_t t_l" style="width: 30px">
					<img src="../../../assets/icon_step2.png" class="w70" alt="">
					</div><div class="d_in v_m" style="width: calc(100% - 30px)"
				>检查一下网络配置</div>
			</div>
			<div class="p_t_b_10">以上操作后如仍出现问题，请联系技术支持人员</div>
		</div>
		<div></div>

  </div>
</template>

<script>
export default {
    name: 'errPage',
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/pages/errPage/errPage.vue